<script lang="ts" setup>
import MarkerPin from '~/assets/icons/marker-pin-04.svg?component'
import MarkerPin2 from '~/assets/icons/marker-pin-05.svg?component'
import Check from '~/assets/icons/check.svg?component'
import CheckGreen from '~/assets/icons/check-green.svg?component'
import Line from '~/assets/line.svg?component'
import type {WorkshopDescription} from '~/types/workshop'

const props = defineProps<{
  data: Exclude<WorkshopDescription, undefined | null>
}>()
</script>

<template>
  <section
    class="relative z-50 grid w-full gap-6 bg-white px-1 sm:w-2/3 sm:gap-8 sm:px-4 lg:px-4 xl:grid-cols-3 xl:gap-12"
  >
    <Line class="absolute z-[100] hidden w-2/3 xl:-top-[40%] xl:left-[5%] xl:block" />
    <div class="col-span-1 rounded-lg border border-gray-200 bg-white p-8 lg:col-span-2">
      <div v-if="data.main" class="mb-6 flex flex-shrink-0 items-center space-x-2">
        <MarkerPin class="h-10 w-10 flex-shrink-0 rounded-full bg-main-100 p-2" />

        <div>
          <span class="text-sm font-bold text-main-600">{{ data.main.eyebrow }}</span>
          <Heading as="h3" size="medium" class="text-main-950">{{ data.main.title }}</Heading>
        </div>
      </div>
      <ul v-if="data.main" class="text-gray-600">
        <li
          v-for="option in data.main.options"
          :key="option.title"
          class="flex list-none items-center gap-2 rounded-md py-2"
        >
          <Check class="h-6 w-6" />
          {{ option.title }}
        </li>
      </ul>
    </div>

    <div
      v-if="data.secondary"
      class="col-span-1 h-[363px] w-[381px] rotate-0 rounded-lg border border-main-200 bg-main-50 p-8 sm:rotate-[2deg] lg:col-span-1"
    >
      <div class="mb-6 flex items-center space-x-2">
        <MarkerPin2 class="h-10 w-10 rounded-full bg-main-100 p-2" />
        <div>
          <span class="text-sm font-bold text-main-600">{{ data.secondary.eyebrow }}</span>
          <Heading size="medium">{{ data.secondary.title }}</Heading>
        </div>
      </div>
      <ul class="text-gray-600">
        <li
          v-for="option in data.secondary.options"
          :key="option.title"
          class="flex list-none items-center gap-2 rounded-md py-2"
        >
          <CheckGreen class="h-6 w-6 flex-shrink-0" />
          {{ option.title }}
        </li>
      </ul>
    </div>
  </section>
</template>
